import { getMessagesControl } from 'providers/Toast';

export const COMMON_MESSAGES = getMessagesControl({
  success: (t) => ({
    title: t('success'),
    type: 'success',
  }),

  error: (t) => ({
    title: t('something-went-wrong'),
    type: 'error',
  }),

  filling: (t) => ({
    title: t('form-filling-incomplete'),
  }),

  makeSureFilling: (t) => ({
    title: t('make-sure-everything-is-filled-correctly'),
  }),
});
